import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import { getSiteGraphqlUrl } from "@hooks/use-site-context/utils";

const SEND_PASSWORD_RESET_EMAIL = gql`
  mutation SendPasswordResetEmail($username: String!) {
    sendPasswordResetEmail(input: { username: $username }) {
      clientMutationId
    }
  }
`;

export const useRequestPasswordReset = () => {
  const [sendResetEmail, { loading }] = useMutation(SEND_PASSWORD_RESET_EMAIL, {
    context: { uri: getSiteGraphqlUrl() },
  });

  const requestPasswordReset = useCallback(
    async (username: string) => {
      try {
        const result = await sendResetEmail({ variables: { username } });
        return result.data?.sendPasswordResetEmail ?? null;
      } catch {
        return null;
      }
    },
    [sendResetEmail]
  );

  return { requestPasswordReset, loading };
};
